import styles from './index.module.less';

export function ShopQuoteItemGrayHint({ children }) {
  return <p className={styles.pp}>{children}</p>;
}
